import React from 'react';
import style from './style.module.scss';
import {Button} from '@material-ui/core';
import {IProps} from './types';

const NS = 'RaisedButton';

export default function Index({text, isDisabled, clickHandler}: IProps) {
  return (
    <Button
      className={style.root}
      disabled={isDisabled}
      variant="contained" color="primary" size="medium"
      onClick={clickHandler}
    >
      {text}
    </Button>
  );
}
